import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: theme.mixins.gutters({
    textAlign: 'center',
    minHeight: '70vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& h1': {
      fontSize: '2.5rem',
      lineHeight: '1.5rem',
      fontWeight: 600,
      color: '#596375',
    },
    '& h2': {
      fontSize: '1rem',
      color: '#596375',
    },
  }),
}));

const NotFound = () => {
  const classes = useStyles();

  return (
    <div>
      <div className={classes.root}>
        <div className='notfound'>
          <h1>Erro 404</h1>
          <br />
          <h2>Ops, página não encontrada...</h2>
          <br />
          <Link to={'/'}>
            <Button variant='contained' color='primary'>
              Ir para tela principal
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
